/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySummary {
    getFixupPrototypeFunction() { return CostAnomalySummary.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySummary>): CostAnomalySummary {
        let obj = Object.assign(new CostAnomalySummary(), model);
        CostAnomalySummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySummary>): CostAnomalySummary {
        if (!model) return null;
        return CostAnomalySummary.newInstance(<CostAnomalySummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySummary) {
        if (!obj) return;

        models.CostAnomalySummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySummary): boolean {
        Object.setPrototypeOf(obj, CostAnomalySummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.anomaly_count === undefined) {
            this.anomaly_count = 0;
        }
        if (this.cost_impact === undefined) {
            this.cost_impact = 0;
        }
        if (this.upper_cost_bound === undefined) {
            this.upper_cost_bound = 0;
        }
        if (this.lower_cost_bound === undefined) {
            this.lower_cost_bound = 0;
        }
        if (this.expected_cost === undefined) {
            this.expected_cost = 0;
        }
        if (this.actual_cost === undefined) {
            this.actual_cost = 0;
        }
        if (typeof this.reject_until === "string") {
            this.reject_until = new Date(<string><any>this.reject_until);
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.CostAnomalyResourceDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Anomaly Type of the cost. Example 'anomaly_type':'above_threshold'
     */
    anomaly_type: models.CostAnomalyType;

    /**
     * Product category wise anomaly count
     */
    anomaly_count: number;

    /**
     * Product category level cost impact
     */
    cost_impact: number;

    /**
     * Anomalous resource details
     */
    resources: Array<models.CostAnomalyResourceDetails>;

    /**
     * Upper cost bound of daily cost anomaly summary
     */
    upper_cost_bound: number;

    /**
     * Lower cost bound of daily cost anomaly summary
     */
    lower_cost_bound: number;

    /**
     * Expected cost of daily cost anomaly summary
     */
    expected_cost: number;

    /**
     * Actual cost of daily cost anomaly
     */
    actual_cost: number;

    /**
     * Rejected Until time for the anomaly
     */
    reject_until: Date;

    /**
     * Rejected Reason
     */
    reject_reason: string;

}
